// Encoding:
// <marker (1 byte)><value>
// marker when all numbers < 2^8 - 1: 0x41
// marker when all numbers < 2^16 - 1: 0x42
// marker when all numbers < 2^32 - 1: 0x44
// So 12 is 0x410c, 256 is 0x420100 etc

import { NUMBER_MARKER_BY_WIDTH } from "./markers";

const SETTER_BY_WIDTH = {
  1: "setUint8",
  2: "setUint16",
  4: "setUint32",
} as const;

export function encodeNumber(num: number): Uint8Array {
  const width = num < 256 ? 1 : num < 65536 ? 2 : 4;
  const setter = SETTER_BY_WIDTH[width];
  const result = new Uint8Array(width + 1);
  const dataView = new DataView(result.buffer);

  result[0] = NUMBER_MARKER_BY_WIDTH[width];
  dataView[setter](1, num);

  return result;
}
